<style lang="less" scoped>
  .orientation-tip {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    color: #fff;
    font-size: 14px;
  }
  .orientation-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, .75);
    p {
      margin: 0;
      padding: 12px;
      background-color: #009999;
      border-radius: 8px;
    }
  }

  @media screen and (orientation: portrait) {
    /*竖屏*/
    .orientation-tip {
      display: none;
    }
  }
  @media screen and (orientation: landscape) {
    /*横屏*/
    .orientation-tip {
      display: flex;
    }
  }
</style>

<template>
  <div class="orientation-tip">
    <p>{{this.$t("请使用竖屏以获得最佳体验")}}</p>
  </div>
</template>

<script>
export default {
  name: 'orientatiion-tip'
}
</script>
